import loadable from '@loadable/component';

export const OrgDashboardViewPaymentPageLoadable = loadable(
  () => import('./OrgDashboardViewPaymentPage'),
  {
    resolveComponent: (module) => module.OrgDashboardViewPaymentPage,
  },
);
